import type { FC } from 'react'
import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import { TextFieldInput, TextFieldInputProps } from './TextFieldInput.js'

export const CompanyNameInput: FC<TextFieldInputProps> = ({ name, ...props }) => {
  const { t } = useTranslation()

  return <TextFieldInput {...props} name={name} type="text" label={t('inputs.companyNameInput.companyNameLabel')} />
}

export const createCompanyNameValidationSchema = (
  t: TFunction
): Yup.StringSchema<string | undefined, Yup.AnyObject, string, 'd'> =>
  Yup.string().default('').max(254, t('inputs.companyNameInput.companyNameIsLongMessage'))
